import React from "react";

import { useViewer } from "../../../app/hooks/hooks";
import ContextMenu from "../../ContextMenu/ContextMenu";
type Position = { x: number; y: number } | null;
interface TreeContextMenuProps {
    position: Position;
    setPosition: React.Dispatch<React.SetStateAction<Position>>;
    getIds: () => number[];
    modelID: number;
    hideTrigger: () => void;
    selectTrigger: () => void;
}

function TreeContextMenu({
    position,
    setPosition,
    getIds,
    modelID,
    hideTrigger,
    selectTrigger,
}: TreeContextMenuProps) {
    const viewer = useViewer();
    const selectHandle = () => {
        if (!viewer) return;
        const ids = getIds();
        viewer.selector.selection.selectByIds(modelID, ids);
        selectTrigger();
    };
    const hideHandle = () => {
        if (!viewer) return;
        const ids = getIds();
        viewer.utils.geometryUtils.hideElementsByIds(modelID, ids);
        hideTrigger();
    };
    const isolateHandle = () => {
        if (!viewer) return;
        const ids = getIds();
        viewer.utils.geometryUtils.isolateElementsByIds(modelID, ids);

        hideTrigger();
    };
    const data = [
        { content: "Select elements", handle: selectHandle },
        { content: "Hide elements", handle: hideHandle },
        { content: "Isolate elements", handle: isolateHandle },
    ];
    return (
        <ContextMenu
            data={data}
            close={setPosition}
            position={position}
            contextRef={null}
        ></ContextMenu>
    );
}

export default TreeContextMenu;
